/**
 * Pull the text of a leading `<h1>`/`<h2>` out of a section's HTML content,
 * for use as the course-outline rail header (which otherwise falls back to
 * the section/course title — see CourseLearnView). Only counts as "leading"
 * if the heading is the first element in the markup; a heading appearing
 * after other content (e.g. an intro `<p>`) doesn't represent the section
 * well enough to headline the rail, so we return null and let the caller
 * fall back.
 */
export function extractLeadingHeading(html) {
  if (!html || typeof html !== 'string') return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const first = doc.body.firstElementChild;
  if (!first || !/^h[12]$/i.test(first.tagName)) return null;

  const text = (first.textContent || '').replace(/\s+/g, ' ').trim();
  return text || null;
}
